<!-- 课程中心 -->
<template>
  <div class="el-CourseCenter">
    <el-row class="content_block mb30">
      <TitleInfo title="课程中心" :titleImg="keczx"></TitleInfo>
      <el-row class="p10" style="margin-bottom: 0px">
        <div style="display: flex; align-items: center">
          <el-input
            style="width: 15rem; margin-right: 1rem"
            v-model="title"
            clearable
          ></el-input>
          <el-button type="primary" @click="getCourseInfo">搜索</el-button>
        </div>
      </el-row>
      <el-row class="p20" style="padding-top: 0px !important">
        <span
          style="
            font-size: 14px;
            float: left;
            line-height: 40px;
            margin-right: 10px;
            width: 75px;
          "
          >所有类别：</span
        >
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          style="margin-right: 20px; width: calc(100% - 95px)"
        >
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <template v-for="(item, index) in courseLabelList">
            <el-tab-pane
              :label="item.courseLabelName"
              :name="item.courseLabelId"
              :key="index + '_'"
            ></el-tab-pane>
          </template>
        </el-tabs>
        <el-row style="min-height: 200px" class="content_">
          <ul>
            <template v-for="(item, index) in courseList">
              <li :key="index">
                <el-row class="img_course_center">
                  <el-image
                    @click="courseHome(item, index)"
                    :src="$processUrl(item.courseCover)"
                    class="img c_p"
                  ></el-image>
                  <el-row class="cz_li">
                    <!-- <el-col :span="12" class="tc" style="border-right: 1px solid white;">
                      <el-link style="color: white;" @click="courseTop(item,index)" :underline="false" type="primary">置顶</el-link>
                    </el-col> -->
                    <el-col :span="24" class="tc">
                      <el-link
                        style="color: white"
                        @click="courseHome(item, index)"
                        :underline="false"
                        type="primary"
                        >查看</el-link
                      >
                    </el-col>
                  </el-row>
                </el-row>
                <el-row class="info">
                  <p class="fontB limit_line_one">{{ item.courseName }}</p>
                  <p class="limit_line_one">创建人：{{ item.name }}</p>
                </el-row>
              </li>
            </template>
          </ul>
          <el-empty
            v-if="courseList.length <= 0"
            description="暂无数据"
          ></el-empty>
        </el-row>
        <div
          class="block"
          style="text-align: right; bottom: 0; width: 96%; margin: 20px"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[14, 20, 50, 100]"
            :page-size="limit"
            background
            :hide-on-single-page="true"
            layout="sizes, prev, pager, next,jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "CourseCenter",
  components: {
    TitleInfo
  },
  data() {
    return {
      userType: this.$Base64.decode(this.$ls.get(this.$getKeyInfo("userType"))),
      keczx: require("../../images/course/keczx@2x.png"),
      activeName: "all",
      total: 0,
      limit: 14,
      page: 1,
      courseLabelList: [],
      courseList: [],
      timeIn: null,
      title: ""
    };
  },
  created() {},
  mounted() {
    this.getInfo();
    this.getCourseInfo();
    //this.addSystem();
  },
  methods: {
    handleClick() {
      this.getCourseInfo();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo() {
      //获取列表
      this.$get("/api/courseLabel/getList.do", {
        courseLabelStatus: 1,
        courseLabelType: "理论课程类"
      }).then(ret => {
        if (ret.code == 0) {
          this.courseLabelList = ret.data;
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    getCourseInfo() {
      this.$post("/api/teacherOpenCourse/getPageList.do", {
        courseLabelId: this.activeName == "all" ? "" : this.activeName,
        teacherOpenCourseStatus: 1,
        courseLabelType: "理论课程类",
        title: this.title
      }).then(ret => {
        if (ret.code == 0) {
          this.total = Number(ret.count);
          this.courseList = ret.data;
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    courseTop() {
      //课程置顶
      this.$message({ message: "置顶成功！", type: "success" });
    },
    courseHome(item, index) {
      //item.type == 2 授权课
      this.$ls.remove(this.$getKeyInfo("on_show"));
      if (item.type == 2) {
        //授权课
        this.$ls.set(this.$getKeyInfo("courseInfoName_"), item.courseName);
      }
      this.$router.push({
        name: "LookCourseHome",
        query: {
          teacherOpenCourseId: item.teacherOpenCourseId,
          courseType: item.type,
          index: 1 + ""
        }
      });
      // if(this.userType == 1){
      //   this.$router.push({name:'CourseHome',query:{teacherOpenCourseId:item.teacherOpenCourseId || item.courseInfoId,index:1+''}});
      // }else{
      //   this.$router.push({name:'TCourseHome',query:{teacherOpenCourseId:item.teacherOpenCourseId || item.courseInfoId,index:1+''}});
      // }
    },
    addSystem() {
      //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get("timeNum"); //获取统一
      this.timeIn = setInterval(() => {
        let param = {
          firstName: "课程中心", //一级名称
          secondName: "课程中心", //二级名称
          useDuration: timeNum / 1000 / 60 //单次使用时长（单位：分钟）
        };
        this.$addSystemUseLog(param);
      }, timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
<style lang="less">
.el-CourseCenter {
  padding: 20px 20px 0;
  .content_block {
    background-color: #ffffff;
  }
  .content_ {
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    li {
      float: left;
      width: 210px;
      height: 210px;
      border: 1px solid #e1e1e1;
      margin: 0 15px 15px 0;
      .info {
        padding: 5px 10px;
      }
      p {
        margin: 0;
        font-size: 14px;
        line-height: 28px;
      }
      .img_course_center {
        width: 100%;
        height: 140px;
        position: relative;
        .img {
          width: 100%;
          height: 140px;
        }
      }
      .cz_li {
        padding: 8px 0;
        position: absolute;
        bottom: 0;
        width: 100%;
        background-color: #2789e2;
        color: white;
        font-size: 14px;
      }
    }
  }
  .el-tabs__nav-wrap::after {
    background-color: white;
  }
  .el-tabs__item {
    padding: 0 10px;
  }
  //宽度小于等于
  @media screen and (max-width: 1536px) {
    .content_ {
      li {
        margin: 0 15px 15px 0;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/course/CourseCenter.vue